import uploadWithProgress from '@aytm/lib/common/upload-with-progress'
import { doPost } from '../doPost'
import { IAssetResponse, IUploadResponse, IUploadUrls } from '../types'
import DevLog from '../../devlog/Module'

const MAX_ITERAION = 70

const getParameterByName = (url: string, name: string) => {
  const escapedName = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + escapedName + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function headersFromGoogleUploadUrl(url: string) {
  const result: { [key: string]: string } = {}
  const signedHeadersStr = getParameterByName(url, 'X-Goog-SignedHeaders')
  if (signedHeadersStr) {
    const signedHeaders = signedHeadersStr.split(';')
    signedHeaders.forEach(header => {
      if ('host' != header) {
        result[header] = getParameterByName(url, header)
      }
    })
  }
  return result
}

export default async function sendFile(
  file: File,
  url: string,
  params: { [proxyParamKey: string]: unknown },
  progressSubscriber?: (event: ProgressEvent) => void,
  statusSubscriber?: (event: IUploadResponse) => void
) {
  const fileData = {
    content_type: file.type,
    filesize: file.size,
    filename: 'image',
    proxy_params: params
  }
  let urls: IUploadUrls = {}
  let iteration = 0

  return new Promise<string | IAssetResponse>((resolve, reject) => {
    doPost<IUploadResponse>(url, fileData)
      .then(response => {
        if (response.status != 'invalid' && response.upload_urls) {
          urls = response.upload_urls
          // return fetch(urls.binary_upload_url, {
          //   method: 'PUT',
          //   headers: {
          //     'Content-Type': file.type,
          //     ...headersFromGoogleUploadUrl(response.upload_urls.binary_upload_url)
          //   },
          //   body: file
          // })
          return uploadWithProgress(
            urls.binary_upload_url,
            {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': file.type,
                ...headersFromGoogleUploadUrl(response.upload_urls.binary_upload_url)
              }
            },
            progressSubscriber
          )
        } else {
          reject('Something went wrong')
          return null
        }
      })
      .then(() => {
        // a refused create already rejected; without urls the next post would go to "undefined"
        if (!urls.finish_upload_url) return
        doPost<IUploadResponse>(urls.finish_upload_url, fileData)
          .then(response => {
            if (response.status != 'invalid') {
              const checkStatus = () => {
                iteration += 1
                if (iteration > MAX_ITERAION)
                  resolve({
                    status: 'error',
                    text: 'timeout',
                    uid: null
                  } as IAssetResponse)
                else
                  doPost<IUploadResponse>(urls.status_upload_url, fileData)
                    .then(assetStatus => {
                      if (statusSubscriber) statusSubscriber(assetStatus)
                      if (assetStatus.text) resolve(assetStatus as IAssetResponse)
                      switch (assetStatus.status) {
                        case 'source_valid':
                        case 'ready': {
                          resolve(
                            assetStatus.image_asset_token ||
                              assetStatus.video_asset_token ||
                              assetStatus.audio_asset_token
                          )
                          break
                        }
                        case 'processing': {
                          if (!assetStatus.text) setTimeout(checkStatus, 1000)
                          break
                        }
                        case 'error': {
                          reject(assetStatus)
                          break
                        }
                        default: {
                          reject(assetStatus)
                          break
                        }
                      }
                    })
                    .catch(error => {
                      console.log(error) // eslint-disable-line no-console
                      setTimeout(checkStatus, 1000)
                    })
              }
              checkStatus()
            } else {
              reject('Finish upload failed')
            }
          })
          .catch((error: Error) => {
            reject(error.message)
            DevLog.error(error, `SW[sendFile]`)
          })
      })
      .catch((error: Error) => {
        reject(error.message)
        DevLog.error(error, `SW[sendFile]`)
      })
  })
}
